const o = {};
function r(c) {
  Object.assign(o, c);
}
export {
  r as addScaleCorrector,
  o as scaleCorrectors
};
